import { SET_GDS_SERVICES_REFUND_INFO } from './actions';
const initialState = null;
function gdsServicesRefundInfoReducer(state = initialState, { type, payload }) {
    switch (type) {
        case SET_GDS_SERVICES_REFUND_INFO:
            return payload;
        default:
            return state;
    }
}
export default gdsServicesRefundInfoReducer;
